import angular from 'angular'
import baseTemplate from 'views/common/template.html'
import inputInvoice from './inputInvoice'
import certification from './specialInvoiceCertification'
import electronImage from './electronImage'
import basedate from './basedata'
import reimburseManage from './reimburseManage'
import financialCounting from './financialCounting'
import invoicePool from './invoicePool'

export default angular
    .module('input', [inputInvoice, certification, electronImage, basedate, reimburseManage,financialCounting,invoicePool])
    .config(['$stateProvider', ($stateProvider) => {
        $stateProvider.state('input', {
            abstract: true,
            url: '/input',
            template: baseTemplate,
        })
    }])
    .name



// WEBPACK FOOTER //
// ./src/app/input/index.js